exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_previewHeader__29Ste{display:flex;flex-direction:row;align-items:center;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"previewHeader": "style_previewHeader__29Ste"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/TenantTagDesignDialog/style.less
// module id = 1836
// module chunks = 8